import React, { useEffect, useState, useRef } from "react";
import { Modal, Button, Typography, Input } from "antd";
import evaApi from "../../services/api/evaApi";
import useChat from "../../stores/useChat";
import useAppSession from "../../stores/useAppSession";
import { useNavigate } from "react-router-dom";

const { Text, Title } = Typography;

export default function ChatRulesModal({ open, onCancel }) {
  const { clientId, sessionId } = useAppSession();
  const {
    habilitaEmail,
    habilitaZendesk,
    habilitaContexto,
    engine,

  } = useChat();

  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [finished, setFinished] = useState(false);

  const navigate = useNavigate();
  const firstCallDone = useRef(false);
  const chatContainerRef = useRef(null);


  const scrollToBottom = () => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    }
  };
  useEffect(scrollToBottom, [messages]);


  useEffect(() => {
    if (!open) return;
    if (firstCallDone.current) return;

    firstCallDone.current = true;
    callAskAiFinal("");
  }, [open]);


  const callAskAiFinal = async (queryText) => {
    try {
      setLoading(true);

      const response = await evaApi.ask_final(
        {
          query: queryText,
          engine,
          memory: "{}",
          searchdocs: !habilitaContexto,
          temperature: 0.1,
          template: !habilitaContexto ? "template_contexto" : "template_internet",
          client_id: clientId,
          email: habilitaEmail,
          zendesk: habilitaZendesk,
          sessionid: sessionId,
          username: `WEB {{${clientId}}}`,
          cl: process.env.REACT_APP_CL,
          engine: engine,
        },
      );

      const data = response.data;

      if (data.message) {
        setMessages((prev) => [...prev, { sender: "bot", text: data.message }]);
      }

      if (data.fim_conversa === true) {
        setFinished(true);
      }
    } catch (err) {
      setMessages((prev) => [
        ...prev,
        { sender: "bot", text: "Erro ao processar a mensagem." },
      ]);
    } finally {
      setLoading(false);
    }
  };


  const handleSend = () => {
    if (!input.trim() || loading) return;

    const text = input.trim();
    setInput("");

    setMessages((prev) => [...prev, { sender: "user", text }]);

    callAskAiFinal(text);
  };

  const handleExitDashboard = () => navigate("/dashboard");

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      centered
      width={600}
      title="Atendimento – Formulário Final"
      styles={{
        body: {
          minHeight: 450,
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-end",
        },
      }}
    >
      {finished ? (
        <div
          style={{
            textAlign: "center",
            padding: 30,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 16,
          }}
        >
          <div
            style={{
              width: 80,
              height: 80,
              borderRadius: "50%",
              background: "#4f9deb22",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <svg
              width="45"
              height="45"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#4f9deb"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="20 6 9 17 4 12" />
            </svg>
          </div>

          <Title level={3} style={{ margin: 0, color: "#4f9deb" }}>
            Formulário Concluído!
          </Title>

          <Text style={{ fontSize: 16, opacity: 0.85 }}>
            Obrigado por responder todas as perguntas.
            <br />
            Suas informações foram registradas com sucesso.
          </Text>

          <Button
            type="primary"
            size="large"
            style={{
              marginTop: 10,
              padding: "10px 30px",
              background: "#4f9deb",
              borderColor: "#4f9deb",
              borderRadius: 8,
              fontSize: 16,
            }}
            onClick={handleExitDashboard}
          >
            Ir para o Dashboard
          </Button>
        </div>
      ) : (
        <>

          <div
            ref={chatContainerRef}
            style={{
              flex: 1,
              minHeight: 350,
              maxHeight: 350,
              overflowY: "auto",
              padding: "12px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-end",
              gap: 12,
              border: "1px solid #e5e5e5",
              borderRadius: 12,
              background: "#fafafa",
              marginBottom: 12,
            }}
          >
            {messages.map((msg, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  justifyContent:
                    msg.sender === "user" ? "flex-end" : "flex-start",
                }}
              >
                <div
                  style={{
                    padding: "10px 14px",
                    borderRadius: 14,
                    background:
                      msg.sender === "user" ? "#4f9deb" : "#e8e8e8",
                    color: msg.sender === "user" ? "white" : "#333",
                    maxWidth: "75%",
                    lineHeight: 1.4,
                  }}
                >
                  {msg.text}
                </div>
              </div>
            ))}
          </div>


          <div style={{ display: "flex", gap: 8 }}>
            <Input
              value={input}
              disabled={loading}
              onChange={(e) => setInput(e.target.value)}
              placeholder="Digite sua resposta..."
              onPressEnter={handleSend}
            />

            <Button
              type="primary"
              loading={loading}
              onClick={handleSend}
              style={{
                background: "#4f9deb",
                borderColor: "#4f9deb",
                width: 100,
              }}
            >
              Enviar
            </Button>
          </div>
        </>
      )}
    </Modal>
  );
}
